import { atom, useAtom } from 'jotai';

export const creatingNewUser = atom(false);

export function useCreatingNewUserAtom() {
  return useAtom(creatingNewUser);
}
